import { FC, useEffect } from 'react';
import { PWC } from '~/adapters/typescript/propsWithChildren';
import { useOptimizely } from '~/contexts/OptimizelyContext';
import { trackFeatureFlag } from '~/adapters/optimizely/trackFeatureFlag';

/**
 * Send GA tags about user's optimizely feature flag decisions.
 * Do not track flags that have `disableGaTagging` variable set to `true` in optimizely.
 */
export const FeatureFlagTracker: FC<PWC> = ({ children }) => {
    const { optimizely } = useOptimizely();

    useEffect(() => {
        const featuresMap = optimizely.getOptimizelyConfig()?.featuresMap;
        if (!featuresMap) {
            return; // this is not expected to happen, in OptimizelyContext we are waiting until optimizely is ready
        }
        Object.values(featuresMap)
            .filter((feature) => !feature.variablesMap.disableGaTagging?.value)
            .forEach((feature) => {
                const decision = optimizely.decide(feature.key);
                const launchDate: string | undefined = feature.variablesMap.launchDate?.value;
                // when user info is not provided, optimizely doesn't make a decision, in that case we do not want to track GA
                const { variationKey } = decision;
                if (!variationKey) {
                    return;
                }
                trackFeatureFlag(decision.flagKey, variationKey, launchDate);
            });
    }, [optimizely]);

    return <>{children}</>;
};
